export enum AnswersStatus {
  NEW = 'new',
  SENT = 'sent',
  EDITED = 'edited',
  DELAYED = 'delayed',
  EXPIRED = 'expired',
}

export enum AnswerSortEnum {
  createdAt_ASC = 'answer.createdAt',
  createdAt_DESC = '-answer.createdAt',
  questionnaireTitle_ASC = 'questionnaire.title',
  questionnaireTitle_DESC = '-questionnaire.title',
  // Owner
  ownerFirstName_ASC = 'owner.firstName',
  ownerFirstName_DESC = '-owner.firstName',
  ownerFirstRussianName_ASC = 'owner.firstRussianName',
  ownerFirstRussianName_DESC = '-owner.firstRussianName',
  // Editor
  editedByFirstName_ASC = 'editedBy.firstName',
  editedByFirstName_DESC = '-editedBy.firstName',
  editedByFirstRussian_ASC = 'editedBy.firstRussianName',
  editedByFirstRussian_DESC = '-editedBy.firstRussianName',
  // HR Manager
  hrFirstName_ASC = 'responsibleHrManager.firstName',
  hrFirstName_DESC = '-responsibleHrManager.firstName',
  hrFirstRussianName_ASC = 'responsibleHrManager.firstRussianName',
  hrFirstRussianName_DESC = '-responsibleHrManager.firstRussianName',
}
